// extracted by mini-css-extract-plugin
module.exports = {"userlist":"style_userlist__3XFvA","avatar":"style_avatar__3GUdN"};